<template>
    <CList @FiltrarC="Lista" :pConfigList="ConfigList" :pFiltro="Filtro" :segurity="segurity">
        <template slot="Filtros">
            <div class="col-auto">
                <label class="col-form-label text-primary">Fecha</label>
            </div>

            <div class="col-auto">
                <Datepicker @input="Lista" v-model="FechaIni" :input-class="Setpicker.Style" :format="Setpicker.Formato" :language="Setpicker.Idioma" placeholder="Fecha Inicial"></Datepicker>
            </div>

            <div class="col-auto">
                <button type="button" @click="BorrarFechas()" class="btn btn-secondary btnpequenio sinBottom">
                    <i class="fa fa-trash"></i>
                </button>
            </div>

            <div class="col-auto">
                <Datepicker @input="Lista" v-model="FechaFin" :input-class="Setpicker.Style" :format="Setpicker.Formato" :language="Setpicker.Idioma" placeholder="Fecha Final"></Datepicker>
            </div>
            
            <div class="col-auto">
                <label class="col-form-label text-primary">Facturas</label>
            </div>

            <div class="col-auto">
                <select @change="Lista" v-model="RegEstatus" class="form-select form-control-search">
                    <option value="A">Todas</option>
                    <option value="B">Canceladas</option>
                </select>
            </div>
        </template>

        <template slot="header">
            <th :class="StyleTh+' text-center'">#</th>
                <th :class="StyleTh">Factura</th>
                <th :class="StyleTh">Fecha Timbrado</th>
                <th :class="StyleTh">Cliente</th>
                <th :class="StyleTh">Cotización</th>
                <th :class="StyleTh">Total</th>
                <th :class="StyleTh">Forma Pago</th>
                <th :class="StyleTh">Facturado</th>
                
            <th :class="StyleTh+' text-center'">Acciones</th>
        </template>

        <template slot="body">
            <tr v-for="(lista,index) in ListaArrayRows" :key="index">
                <td class="text-center"><p :class="StyleTd">{{(index+1)}}</p></td>
                <td>
                    <div class="form-check form-switch">
                        <input class="form-check-input" type="checkbox" role="switch" :id="'flexSwitchCheckDefault'+index">
                        <label class="form-check-label" :for="'flexSwitchCheckDefault'+index">
                            <h6 :class="StylePr">{{lista.Serie+' - '+lista.Folio}}</h6>
                        </label>
                    </div>
                </td>
                <td><p :class="StyleTd">{{lista.FechaTimbrado}}</p></td>
                <td><p :class="StyleTd">{{lista.NombreCliente}}</p></td>
                <td><p :class="StyleTd">{{lista.Cotizacion}}</p></td>
                <td><p :class="StyleTd">{{$formatNumber(lista.Total,'$')}}</p></td>
                <td><p :class="StyleTd">{{$cambiarGuion(lista.FormaPago)}}</p></td>
                <td><p :class="StyleTd">{{lista.Facturado}}</p></td>
                    
                <td class="align-middle text-end">
                    <CBtnAccion :pShowBtnEdit="false" :pShowBtnDelete="false" :pIsModal="false" :pId="lista.IdFactura" :pEmitSeccion="ConfigList.EmitSeccion" :pGoRoute="ConfigList.GoRoute" :segurity="segurity" :pObj="ConfigList.Obj">
                        <template slot="btnaccion">
                            <button type="button" @click="VerPdfFactura(lista)" class="btn btn-link text-danger px-3 mb-0 mr-1">
                                <i class="fas fa-file-pdf text-danger me-2" aria-hidden="true"></i>PDF
                            </button>

                            <button type="button" @click="$downloadXmlCFDI('0',lista.IdFactura)" class="btn btn-link text-secondary px-3 mb-0" >
                                <i class="fas fa-file-code me-2" aria-hidden="true"></i> Xml
                            </button>

                        </template>
                    </CBtnAccion>     
                </td>
            </tr>
            <CSinRegistros :pContIF="ListaArrayRows.length" :pColspan="9"></CSinRegistros>
        </template>
    </CList>

</template>
<script>

import moment from 'moment';
import Configs from '@/helpers/VarConfig.js';
const EmitEjecuta = 'seccionFactura';
import Calendar from '@/helpers/StaticComboBox.js';

export default {
    name: 'ListaFactura',
    props:['pObjEnviado','pOrigen'],
    components: {
    },
    data() {
        return {
            ConfigList:{
                Title: 'Facturas CFDI ',
                IsModal: false,
                /*ShowYear: true,*/
                ShowLoader: true,
                BtnReturnShow: true,
                EmitSeccion: EmitEjecuta,
                TitleFirst: '',
                BtnNewShow: false,
            },
            Filtro:{
                Nombre: '',
                Pagina: 1,
                Entrada: 25,
                TotalItem: 0,
                Placeholder: 'Buscar..',
                /*Anio: moment(new Date()).format('YYYY'),*/
            },
            segurity: {},
            RegEstatus: 'A',
            FechaIni: '',
            FechaFin: '',
            ListaArrayRows: [],
            StyleTh: Configs.stylesTable.StyleTh,
            StylePr: Configs.stylesTable.StylePr,
            StyleTd: Configs.stylesTable.StyleTd,
            Setpicker: Calendar.calendarSettings,
            ObjCotizacion: {},
            LugarOrigen: '',
            RutaReturn: '',
        }
    },
    methods: {
		async Lista()
        {
            this.ConfigList.ShowLoader = true;
            

            let FechaIni = '';
            let FechaFin = '';

            if(this.FechaIni !=''){
                let YearInicio = this.FechaIni.getFullYear();
                let MonthInicio = this.FechaIni.getMonth()+1;
                let DayInicio = this.FechaIni.getDate();
                FechaIni = YearInicio+'-'+MonthInicio+'-'+DayInicio;
            }

            if(this.FechaFin !=''){
                let YearInicioF = this.FechaFin.getFullYear();
                let MonthInicioF = this.FechaFin.getMonth()+1;
                let DayInicioF = this.FechaFin.getDate();
                FechaFin = YearInicioF+'-'+MonthInicioF+'-'+DayInicioF;
            }

            let objSearch = {
                TxtBusqueda: this.Filtro.Nombre,
                Entrada: this.Filtro.Entrada,
                Pag: this.Filtro.Pagina,
                RegEstatus: this.RegEstatus,
                FechaIni: FechaIni,
                FechaFin: FechaFin,
                Facturado: 'SI',
            };

            await this.$http.get("facturasTimbradas",{
                params: objSearch

            }).then((res) => {
                this.Filtro.Pagina      = res.data.data.current_page;
                this.Filtro.TotalItem   = res.data.data.total;
                this.ListaArrayRows     = res.data.data.data;
                this.segurity           = res.data.segurity;
                
            }).finally(()=>{
                this.ConfigList.ShowLoader = false;
            });
        },
        Eliminar(Id)
        {
            this.$swal(Configs.configEliminar).then((result) =>
            {
                if(result.value)
                {
                    this.$http.delete('facturas/'+Id
                    ).then((res) => {
                        this.$swal(Configs.configEliminarConfirm);
                        this.Lista();
                    }).catch(err => {
                        this.$toast.error(err.response.data.message);
                    });
                } 
            });
        },
        Regresar(){
            this.$router.push({name:this.RutaReturn,params:{}});
        },
        VerPdfFactura(item)
        {
            this.ConfigList.ShowLoader = true;

            let newRequest = {
				IdFactura: item.IdFactura
			}

			this.$http.post('rptpdffactura',newRequest).then((res)=>{     
				
				let pdfWindow = window.open("Factura",'Factura_'+item.IdFactura,'_blank');
				pdfWindow.document.write(
					"<iframe width='100%' height='100%' src='data:application/pdf;base64, " +
					encodeURI(res.data.pdf) + "'></iframe>"
				);
                
			}).catch(err=>{
                this.$toast.error('Ocurrio un problema, intentar mas tarde');
				console.log(err);
			}).finally(()=>{
                this.ConfigList.ShowLoader = false;
            });
        },
        downloadXmlFactura(lista)
        {
            // let urlPdf = `${this.$http.defaults.baseURL}/getxmlcfdi?TipoXml=0&CFDI=${lista.IdFactura}`;
            // window.open(urlPdf,'download');
            this.$bases('0',lista.IdFactura);
            /* this.$http.get("getxmlcfdi",{
                params: {
                    TipoXml: '0',
                    CFDI: lista.IdFactura,
                }

            }).then((response) => {
                let theBlob = response.data.data;
                let Archivo = response.data.filename;
                this.$dowloadFileXml(theBlob,Archivo);

                return response;
            }).catch(err=>{
                this.$toast.error('Ocurrio un problema, intentar mas tarde');
				console.log(err);
			}); */
        },
        BorrarFechas()
        {
            this.FechaIni = '';
            this.FechaFin = '';
            this.Lista();
        },
        
    },
    created()
    {
        if(this.pOrigen != undefined){
            sessionStorage.setItem('menuOrigen',JSON.stringify(this.pOrigen));
        }

        let Origen = JSON.parse(sessionStorage.getItem('menuOrigen'));
        if(Origen){
            this.ConfigList.TitleFirst = Origen;
        }
        else{
            this.ConfigList.ShowTitleFirst = false;
        }

        this.RutaReturn = 'panelSubMenus';

        this.bus.$off('Delete_'+EmitEjecuta);
        this.bus.$off('List_'+EmitEjecuta);
        this.bus.$off('EmitReturn');
    },
    mounted()
    {
        this.Lista();
        this.bus.$on('Delete_'+EmitEjecuta,(Id)=>
        {
            this.Eliminar(Id);
        });

        this.bus.$on('List_'+EmitEjecuta,()=>
        {
            this.Lista();
        });

        this.bus.$on('EmitReturn',()=>
        {
            this.Regresar();
        });
    }
}
</script>
